<template>
	<section class="locations-overview">
		<div class="row row-header align-left">
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<nuxt-link v-if="moreButtonLabel" class="button button-no-fill" :to="localePath('hotels')">
					{{ moreButtonLabel }}
				</nuxt-link>
			</div>
		</div>
		<div class="row locations-row">
			<div v-if="rows[0]" class="row promotions-row flex-row slide-row full-visible">
				<HotelOverviewCard v-for="item in rows[0]" :key="item.ID" :item="item" :locale-path="localePath" />
			</div>

			<div v-if="rows[1]" class="row promotions-row flex-row slide-row second-row" :class="{ expanded: showAll }">
				<HotelOverviewCard v-for="item in rows[1]" :key="item.ID" :item="item" :locale-path="localePath" />
			</div>

			<div
				v-for="(row, index) in rows.slice(2)"
				v-show="showAll"
				:key="index"
				class="row promotions-row flex-row slide-row"
			>
				<HotelOverviewCard v-for="item in row" :key="item.ID" :item="item" :locale-path="localePath" />
			</div>
			<!-- <div v-if="rows.length > 1" class="show-more-button" @click="showAll = !showAll">
				<span>{{ showAll ? $t('hotelShowLess') : $t('hotelShowMore') }}</span>

				<svg
					class="arrow-icon"
					:class="{ rotated: showAll }"
					width="10"
					height="6"
					viewBox="0 0 10 6"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1 1L5 5L9 1"
						stroke="#c0924a"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</div> -->
		</div>
	</section>
</template>

<script setup>
import HotelOverviewCard from '../HotelOverviewCard.vue';
const localePath = useLocalePath();

const props = defineProps({
	type: { type: String, default: 'hotels' },
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 24 },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	viewButtonLabel: { type: String, default: '' },
	moreButtonLabel: { type: String, default: '' },
});

const rows = computed(() => {
	const size = 4;
	const limitedPackages = props.amount ? props.items.slice(0, props.amount) : props.items;
	const out = [];
	for (let i = 0; i < limitedPackages.length; i += size) {
		out.push(limitedPackages.slice(i, i + size));
	}

	return out;
});
const showAll = ref(true);
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 1680px;
	padding: 0 16px;
}

.columns {
	padding: 0;
	display: flex;
	justify-content: space-between;
}

.button {
	align-self: center;
	margin: 0;
}

.slide-row {
	overflow: hidden;
	padding: 20px 16px;
	flex-flow: row wrap;
	justify-content: unset;
	gap: 2%;

	.slick-item {
		width: 23.5%;
	}
}

.locations-overview {
	padding: 20px 0 50px;

	.locations-row {
		justify-content: center;
		width: 100%;
		max-width: 100%;

		.second-row {
			max-height: 20px;
			overflow: hidden;
			position: relative;
			transition: max-height 0.8s ease-in-out;

			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 50px;
				background: linear-gradient(to bottom, rgb(255 255 255 / 0%) 0%, rgb(255 255 255 / 100%) 100%);
				pointer-events: none;
				transition: opacity 0.3s ease;
			}

			&.expanded {
				max-height: 1000px;

				&::after {
					opacity: 0;
				}
			}
		}

		.show-more-button {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 6px;
			margin: 24px auto;
			cursor: pointer;
			font-size: var(--button-font-size);
			text-transform: uppercase;
			color: var(--cta-color);
			font-weight: 500;
			letter-spacing: 0.05em;
			border-top: 1px solid var(--header-color);
			padding-top: 12px;
			width: 94%;
			max-width: 1650px;

			.arrow-icon {
				transition: transform 0.3s ease;
			}

			.arrow-icon.rotated {
				transform: rotate(180deg);
			}
		}
	}

	.content {
		.button {
			min-width: 210px;
			text-align: center;
			margin: 8px 10px 8px 0;
		}
	}
}
</style>
